import { Outlet } from 'react-router-dom'

import SiteWorksLogo from '@/assets/SiteWorks_Logo.svg'
import SouthernWaterLogo from '@/assets/Southern_Water_Logo.svg'
import { ProfileMenu } from '@/features/auth/components/profile-menu'

export const SiteWorkerLayout = () => (
  <div className="relative flex min-h-dvh flex-col bg-surface-tint">
    <header className="flex h-26 shrink-0 items-center justify-between px-8">
      <h1 className="m-0">
        <img
          src={SiteWorksLogo}
          alt="SiteWorks"
          className="h-10 w-auto"
        />
      </h1>

      <ProfileMenu />
    </header>

    <main className="flex-1 overflow-auto px-8 pb-24">
      <div className="rounded-xl bg-background p-2">
        <Outlet />
      </div>
    </main>

    <img
      src={SouthernWaterLogo}
      alt="Southern Water"
      className="absolute bottom-8 left-8 h-10.5 w-auto"
    />
  </div>
)
